<template>
  <div>
    <Row :gutter="8">
      <Col span="4">
        <Input v-model="name" type="text" placeholder="姓名" clearable @on-clear="searchChange" />
      </Col>
      <Col span="4">
        <Input v-model="idCard" type="text" placeholder="身份证号码" clearable @on-clear="searchChange" />
      </Col>
      <Col span="3">
        <Select v-model="year" placeholder="年份" clearable @on-change="search">
          <Option v-for="y in yearList" :key="y" :value="y">{{ y }}</Option>
        </Select>
      </Col>
      <Col span="9">
        <Button type="primary" icon="ios-search" @click="search" style="margin-right:5px">查询</Button>
        <Button
          type="success"
          icon="md-add"
          @click="jump('integralPeopleItemAdd', { action: 'add' })"
          style="margin-right: 5px"
          >新增</Button
        >
        <Button
          type="primary"
          ghost
          icon="ios-cloud-upload-outline"
          style="margin-right: 5px"
          @click="importShow = true"
          >导入</Button
        >
        <Button
          type="primary"
          ghost
          icon="ios-cloud-download-outline"
          style="margin-right: 5px"
          @click="exportData"
          >导出</Button
        >
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Table
          border
          ref="table"
          size="small"
          :columns="columns"
          :data="tableData"
          :height="tableHeight"
        ></Table>
      </Col>
    </Row>
    <Row>
      <Col span="24" style="text-align: center">
        <Page
          :total="total"
          :page-size="pageSize"
          :current="pageNumber"
          show-elevator
          show-sizer
          show-total
          @on-change="pageChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
    <import-item-modal
      v-model="importShow"
      @getList="getData"
    ></import-item-modal>
  </div>
</template>

<script>
export default {
  name: "integralPeopleItem",
  components: {
    "import-item-modal": () => import("./integralPeopleItemImport.vue"),
  },
  data() {
    return {
      importShow: false,
      // 搜索内容
      name: "",
      idCard: "",
      year: "",
      yearList: [],
      columns: [
        {
          title: "序号",
          width: 80,
          align: "center",
          render: (h, params) => {
            return h("span", params.index + 1);
          },
        },
        {
          title: "日期",
          key: "recordDate",
          minWidth: 120,
          align: "center",
          tooltip: true,
        },
        {
          title: "姓名",
          key: "name",
          minWidth: 100,
          align: "center",
          tooltip: true,
        },
        {
          title: "身份证号码",
          key: "idCard",
          minWidth: 180,
          align: "center",
          tooltip: true,
        },
        {
          title: "参与大类",
          key: "category",
          minWidth: 180,
          align: "center",
          tooltip: true,
        },
        {
          title: "具体事项",
          key: "detail",
          minWidth: 200,
          align: "center",
          tooltip: true,
        },
        {
          title: "积分",
          key: "branch",
          minWidth: 80,
          align: "center",
          tooltip: true,
        },
        {
          title: "审核状态",
          key: "status",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.status == 10 ? "已审核" : "待审核");
          },
        },
        {
          title: "操作",
          minWidth: 250,
          align: "center",
          render: (h, params) => {
            if (params.row.status == 10) {
              return h("div", [
                h("Button", { style: { margin: "0 5px" }, props: { type: "info", size: "small" }, on: { click: () => { this.jump("integralPeopleItemAdd", { action: "detail", id: params.row.id }); } } }, "查看"),
              ]);
            }
            return h("div", [
              h("Button", { style: { margin: "0 5px" }, props: { type: "success", size: "small" }, on: { click: () => { this.jump("integralPeopleItemAdd", { action: "edit", id: params.row.id }); } } }, "修改"),
              h("Button", { style: { margin: "0 5px" }, props: { type: "info", size: "small" }, on: { click: () => { this.jump("integralPeopleItemAdd", { action: "detail", id: params.row.id }); } } }, "查看"),
              h("Button", { style: { margin: "0" }, props: { type: "error", size: "small" }, on: { click: () => { this.deleteConfirm(params.row.id); } } }, "删除"),
            ]);
          },
        },
      ],
      // 表格数据
      tableData: [],
      // 表格高度
      tableHeight: 500,
      // 分页条
      total: 0,
      pageNumber: 1,
      pageSize: 10,
    };
  },
  created() {
    this.initYearList();
    this.getData();
  },
  mounted() {
    this.tableHeight =
      window.innerHeight - this.$refs.table.$el.offsetTop - 220;
  },
  methods: {
    /**
     * @description 请求列表
     */
    getData() {
      let msg = this.$Message.loading({
        content: "正在获取数据",
        duration: 0,
      });
      let params = {
        name: this.name,
        idCard: this.idCard,
        year: this.year,
        currentPage: this.pageNumber,
        pageSize: this.pageSize,
      };
      this.$http
        .get("/api/tIntegralPeopleItem/page", { params: params })
        .then((res) => {
          msg();
          if (res.data.code == 200) {
            this.tableData = res.data.data.list;
            this.total = res.data.data.total;
          }
        })
        .catch((err) => {
          msg();
        });
    },
    /**
     * @description 搜索
     */
    search() {
      this.pageNumber = 1;
      this.getData();
    },
    /**
     * @description 分页页数改变
     */
    pageChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.getData();
    },
    /**
     * @description 分页每页条数改变
     */
    pageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNumber = 1;
      this.getData();
    },
    /**
     * @description 删除弹框
     */
    deleteConfirm(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "确认删除该选项？",
        onOk: () => {
          this.deleteEvent(id);
        },
      });
    },
    deleteEvent(id) {
      this.$http
        .get("/api/tIntegralPeopleItem/delete", { params: { id: id } })
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("删除成功");
            this.getData();
          } else {
            this.$Message.error(res.data.msg || "删除失败");
          }
        })
        .catch(() => {
          this.$Message.error("删除失败");
        });
    },
    searchChange() {
      this.getData();
    },
    initYearList() { var y = new Date().getFullYear(); for (var i = y - 4; i <= y; i++) this.yearList.push(i + ""); },
    exportData() {
      let msg = this.$Message.loading({ content: "正在导出", duration: 0 });
      this.$http
        .get("/api/tIntegralPeopleItem/export", {
          params: { name: this.name, idCard: this.idCard, year: this.year },
          responseType: "blob",
        })
        .then((res) => {
          msg();
          const link = document.createElement("a");
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "个人积分明细.xlsx";
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
          this.$Message.success("导出成功");
        })
        .catch(() => {
          msg();
          this.$Message.error("导出失败");
        });
    },
  },
};
</script>

<style scoped>
.ivu-row {
  margin-bottom: 10px;
}
</style>
